import { render, staticRenderFns } from "./EditaEvaluacionDesempeñoAcademicoDialogContent.vue?vue&type=template&id=72c98ec0"
import script from "./EditaEvaluacionDesempeñoAcademicoDialogContent.vue?vue&type=script&lang=js"
export * from "./EditaEvaluacionDesempeñoAcademicoDialogContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports